module.exports = __webpack_public_path__ + "static/media/9ditton_edited.8c8b0b5e.jpg";